import React from 'react'
import { motion } from 'framer-motion'
import { TEAM_MEMBERS } from '../config/constants'

const Team: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Meet Our Expert
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Highly qualified physiotherapist dedicated to your recovery
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {TEAM_MEMBERS.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="card p-8 text-center"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="w-40 h-40 mx-auto mb-6 rounded-full overflow-hidden"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </motion.div>
              
              <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                {member.name}
              </h3>
              
              <p className="text-primary-600 dark:text-primary-400 font-semibold mb-4 text-lg">
                {member.title}
              </p>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Qualifications</h4>
                <p className="text-gray-600 dark:text-gray-300 text-sm whitespace-pre-line">
                  {member.qualifications}
                </p>
              </div>
              
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                {member.bio}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Detailed profile section removed; using existing team member card only */}
      </div>
    </div>
  )
}

export default Team
